import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=60c8d3d2&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"
import style0 from "./heading.vue?vue&type=style&index=0&id=60c8d3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8d3d2",
  null
  
)

export default component.exports